var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.enabledExtraFilters.length
    ? _c(
        "v-row",
        { class: _vm.rowClass },
        [
          _vm._l(_vm.enabledExtraFilters, function (key) {
            return _c(
              "v-col",
              { key: key, class: _vm.colClass, attrs: { cols: _vm.cols } },
              [
                _vm.definitions[key].type === "text"
                  ? _c("v-text-field", {
                      ref: key,
                      refInFor: true,
                      class: {
                        "to-upper-text": _vm.definitions[key].upperCase,
                      },
                      attrs: {
                        value: _vm.filterSelection[key]?.text,
                        label: _vm.$t(_vm.definitions[key].label),
                        "prepend-inner-icon": _vm.definitions[key].icon,
                        "hide-details": "",
                        clearable: "",
                        dense: "",
                      },
                      on: { input: (v) => _vm.onInput(v, key) },
                    })
                  : _vm.definitions[key].type === "date"
                  ? _c(
                      "v-menu",
                      {
                        attrs: {
                          transition: "scale-transition",
                          "offset-y": "",
                          "min-width": "auto",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    "v-text-field",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          ref: key,
                                          refInFor: true,
                                          attrs: {
                                            value:
                                              _vm.filterSelection[key]?.text,
                                            label: _vm.$t(
                                              _vm.definitions[key].label
                                            ),
                                            "prepend-inner-icon":
                                              _vm.definitions[key].icon,
                                            "hide-details": "",
                                            clearable: "",
                                            readonly: "",
                                            dense: "",
                                          },
                                          on: {
                                            "click:clear": function ($event) {
                                              return _vm.onDateInput(null, key)
                                            },
                                          },
                                        },
                                        "v-text-field",
                                        attrs,
                                        false
                                      ),
                                      on
                                    )
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c("v-date-picker", {
                          attrs: {
                            value: _vm.filterSelection[key]?.value,
                            color: "primary",
                          },
                          on: { input: (v) => _vm.onDateInput(v, key) },
                        }),
                      ],
                      1
                    )
                  : _vm.definitions[key].type === "select"
                  ? _c("CustomAutocomplete", {
                      ref: key,
                      refInFor: true,
                      attrs: {
                        current: _vm.filterSelection[key],
                        value: "id",
                        text: "name",
                        label: _vm.$t(_vm.definitions[key].label),
                        icon: _vm.definitions[key].icon,
                        textClass: _vm.textClass,
                        allowEmptySearch: true,
                      },
                      on: {
                        select: (v) =>
                          _vm.$emit("change", v, key, "value", "text"),
                        browse: (v) => _vm.browseSelectItems(v, key),
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          }),
          _vm.$scopedSlots.actions
            ? _c(
                "v-col",
                {
                  staticClass: "d-flex align-end justify-end",
                  class: _vm.colClass,
                },
                [_vm._t("actions")],
                2
              )
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }